const nr =
    typeof window !== "undefined" &&
    typeof window.NREUM === "object" &&
    window.NREUM;

export const logError = (err: Error, attributes = {}) => {
    if (nr) nr.noticeError(err, attributes);
};
